export default "__VITE_ASSET__b30ca03b__"